export const FeaturesList = [
    "clientDisclosures",
    "clientReferralSourceView",
    "customReportsDownload",
    "customReportsSchedule",
    "customReportsUnlimitedSave",
    "customRoles",
    "discreteLicenseeField",
    "discreteLicenseRecords",
    "enhancedSentMessageView",
    "fax",
    "hostedIntakeFormCustomizable",
    "hostedIntakeFormUnlimited",
    "hostedIntakeFormExisting",
    "hostedIntakeFormFileUpload",
    "integrationAccounts",
    "quickbooks",
    "signwiseUnlimited",
    "workflows",
    "customizeClientStatus",
    "simpleSearch",
    "mailboxSync",
    "shareReferralLink",
    "paperIntake",
    "communityPaperIntake",
    "mailchimp",
    "constantContact",
    "reportsV2",
    "clientCollaborators",
    "webhooks",
    "twilioIntegration",
    "unifiedTimeline",
    "referralSourceReport",
    "stageConversion",
    "homeCarePrototype",
    "franchiseManagement",
    "outstandingInvoicesReport",
    "placement",
];
export var BillableEntitySource;
(function (BillableEntitySource) {
    BillableEntitySource["Explicit"] = "Explicit";
    BillableEntitySource["Upstream"] = "Upstream";
})(BillableEntitySource || (BillableEntitySource = {}));
export const tenantSkus = ["basic", "premium", "homeCare"];
export var FeatureTrack;
(function (FeatureTrack) {
    FeatureTrack["Standard"] = "Standard";
    FeatureTrack["Beta"] = "Beta";
})(FeatureTrack || (FeatureTrack = {}));
export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["Disabled"] = "Disabled";
    FeatureStatus["Enabled"] = "Enabled";
    FeatureStatus["Beta"] = "Beta";
})(FeatureStatus || (FeatureStatus = {}));
export const featureMetadata = {
    clientReferralSourceView: {
        friendlyTitle: "Client Referral Source View",
        description: "Find clients via referral source owner",
        createdOn: "2021-11-01",
        intent: "setting",
    },
    discreteLicenseeField: {
        friendlyTitle: "DEPRECATED Licensee Field",
        description: "DEPRECATED - Use discreteLicenseRecords instead. (formerly: A separate licensee field that is searchable)",
        createdOn: "2022-01-31",
        intent: "rollout",
    },
    enhancedSentMessageView: {
        friendlyTitle: "Enhanced Sent Message View",
        description: "Display stats for sent messages",
        createdOn: "2022-03-25",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    discreteLicenseRecords: {
        friendlyTitle: "Discrete License Records",
        description: "Each community can have several licenses tracked",
        createdOn: "2022-08-31",
        intent: "rollout",
    },
    fax: {
        friendlyTitle: "Outbound fax",
        description: 'Send client intake via fax (Be sure to enable "Enhanced Sent Message View"/"enhancedSentMessageView" as well)',
        createdOn: "2022-10-19",
        intent: "packaging",
        skus: ["premium", "homeCare"],
    },
    customReportsDownload: {
        friendlyTitle: "Custom Reports Downloads",
        description: "Allow downloading custom report results",
        createdOn: "2023-01-24",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    customReportsSchedule: {
        friendlyTitle: "Custom Reports Scheduling",
        description: "Allow emailing custom report results on a schedule",
        createdOn: "2023-05-30",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    customReportsUnlimitedSave: {
        friendlyTitle: "Custom Reports Unlmitied Save",
        description: "Allow saving more than 1 custom report",
        createdOn: "2023-05-18",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    clientDisclosures: {
        friendlyTitle: "Client Disclosures",
        description: "Email automation and tracking for client disclosures",
        createdOn: "2022-11-16",
        intent: "packaging",
        skus: ["premium"],
    },
    hostedIntakeFormCustomizable: {
        friendlyTitle: "Hosted Intake Form with Customization",
        description: "Customize the hosted intake form with custom questions",
        createdOn: "2023-05-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    hostedIntakeFormUnlimited: {
        friendlyTitle: "Multiple Hosted Intake Forms",
        description: "Create and host multiple intake forms",
        createdOn: "2024-06-18",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    hostedIntakeFormExisting: {
        friendlyTitle: "Hosted Intake Form - Existing Clients",
        description: "Allow hosted intake form to be used for existing clients",
        createdOn: "2023-05-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    signwiseUnlimited: {
        friendlyTitle: "SignWise Unlimited Add-on",
        description: "Removes signature template limit for SignWise",
        createdOn: "2023-05-05",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    workflows: {
        friendlyTitle: "Workflows",
        description: "Allows user-created workflows",
        createdOn: "2023-05-09",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    integrationAccounts: {
        friendlyTitle: "Integration Accounts",
        description: "Allows user-created integration accounts for API integrations",
        createdOn: "2023-10-18",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: false,
    },
    customRoles: {
        friendlyTitle: "Custom Roles",
        description: "Allows users to be created with custom permission sets",
        createdOn: "2023-10-25",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    customizeClientStatus: {
        friendlyTitle: "Customize Client Status",
        description: "Allows users to create custom client statuses",
        createdOn: "2024-03-07",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    quickbooks: {
        friendlyTitle: "QuickBooks Integration",
        description: "Allows users to integrate with QuickBooks",
        createdOn: "2024-03-12",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    simpleSearch: {
        friendlyTitle: "Simple Search",
        description: "Allows users to search sitewide",
        createdOn: "2024-06-24",
        intent: "rollout",
    },
    mailboxSync: {
        friendlyTitle: "Mailbox Sync",
        description: "Sync your mailbox to Senior Place",
        createdOn: "2025-04-17",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: false,
    },
    shareReferralLink: {
        friendlyTitle: "Share Referral Link",
        description: "Share a referral link",
        createdOn: "2025-05-06",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    paperIntake: {
        friendlyTitle: "Paper Intake",
        description: "Allows users to upload paper intake forms to create and/or updateclients",
        createdOn: "2025-06-17",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    communityPaperIntake: {
        friendlyTitle: "Community Paper Intake",
        description: "Allows users to upload paper intake forms to create and/or update communities",
        createdOn: "2025-06-25",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    mailchimp: {
        friendlyTitle: "Mailchimp Integration",
        description: "Allows users to integrate with Mailchimp",
        createdOn: "2025-07-03",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    constantContact: {
        friendlyTitle: "Constant Contact Integration",
        description: "Allows users to integrate with Constant Contact",
        createdOn: "2025-08-06",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    hostedIntakeFormFileUpload: {
        friendlyTitle: "Hosted Intake Form - File Upload",
        description: "Allow file uploads during hosted intake form submission",
        createdOn: "2025-07-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    reportsV2: {
        friendlyTitle: "Reports v2",
        description: "Advanced analytics and reporting dashboard with interactive charts",
        createdOn: "2025-08-08",
        intent: "rollout",
    },
    clientCollaborators: {
        friendlyTitle: "Client Collaborators",
        description: "Allow users to collaborate on clients not assigned to them",
        createdOn: "2025-09-04",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    webhooks: {
        friendlyTitle: "Webhooks",
        description: "Receive real-time notifications when events occur in your account",
        createdOn: "2025-10-01",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    twilioIntegration: {
        friendlyTitle: "Twilio Integration",
        description: "Allows users to integrate with Twilio for SMS and voice calls",
        createdOn: "2025-11-25",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    unifiedTimeline: {
        friendlyTitle: "Unified Timeline",
        description: "Merges notes and activity into a single timeline on entity pages",
        createdOn: "2026-02-25",
        intent: "rollout",
    },
    referralSourceReport: {
        friendlyTitle: "Referral Source Report",
        description: "Referral source performance report",
        createdOn: "2026-02-28",
        intent: "rollout",
    },
    stageConversion: {
        friendlyTitle: "Stage Conversion Report",
        description: "Stage conversion analytics showing how clients move through pipeline stages",
        createdOn: "2026-02-27",
        intent: "rollout",
    },
    homeCarePrototype: {
        friendlyTitle: "Home Care Prototype",
        description: "Enables the Home Care Client pipeline and related functionality",
        createdOn: "2026-03-03",
        intent: "packaging",
        skus: ["homeCare"],
        packageEnabled: true,
    },
    franchiseManagement: {
        friendlyTitle: "Franchise Management",
        description: "Franchise territory management for geographic territory assignment",
        createdOn: "2026-03-12",
        intent: "setting",
    },
    outstandingInvoicesReport: {
        friendlyTitle: "Outstanding Invoices Report",
        description: "Report showing outstanding invoices with overdue, upcoming, and new/unsent sections",
        createdOn: "2026-03-19",
        intent: "rollout",
    },
    placement: {
        friendlyTitle: "Placement",
        description: "Enables the placement pipeline, community search, and related functionality",
        createdOn: "2026-03-09",
        intent: "packaging",
        skus: ["basic", "premium"],
        packageEnabled: true,
    },
};
//# sourceMappingURL=features.js.map